import { useCallback, useEffect, useState,useRef } from "react";
import { useListSearch } from "../../../common/hooks";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { connect } from "react-redux";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import * as ListCellRenders from "../../../common/list/ListCellRenders";
// import {
//   userExportRequest,
// } from "../../../../store/slices/usersSlice";
import {
     GetNotificationLogsSuccess,
  GetNotificationLogsFailure,
  GetNotificationLogs,
  listRequest,
    setQuery,
    notificationExportRequest
} from "../../../../store/slices/notificationSlice";
import List from "../../../common/list";
import { Dialog } from "primereact/dialog";
// import AudienceUserList from "./AudienceUserList";
import { TextInput } from "../../../common/fields";
import useMobileView from "../../../common/hooks/useMobileView";
import { Menu } from "primereact/menu";
import DropdownButton from "../../../common/dropDownButton";

export const NotificationLogList = ({
  labels,
  user,
  listRequest,
  action,
  error,
  query,
  requesting,
  setQuery,
  totalCount,
  isFromAssigment = false,
  getNotificationLogs,
  notificationLogs,
  filters,
  notificationExportRequest
}) => {
  const navigate = useNavigate();
  const [namePattern, setNamePattern] = useListSearch(
    query?.namePattern,
    (value) => setQuery({ ...query, namePattern: value, pageNo: 1 })
  );
  const [createdByNamePattern, setCreatedByNamePattern] = useState("");

  const intl = useIntl();

  const { isMobile } = useMobileView();

  const menuRef = useRef();


//   const fetchList = useCallback(() => {
//     listRequest({
//       ...query,
//     });
//   }, [query, listRequest]);

//   useEffect(() => {
//     fetchList();
//   }, [fetchList]);

//   useEffect(() => {
//     if (
//       !requesting &&
//       !error &&
//       (action === "create" || action === "update" || action === "delete")
//     ) {
//       fetchList();
//     }
//   }, [action, requesting, error]);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (query?.createdBy !== createdByNamePattern) {
//         setQuery({ ...query, createdBy: createdByNamePattern, pageNo: 1 });
//       }
//     }, 500);

//     return () => clearTimeout(timer);
//   }, [createdByNamePattern, setQuery, query]);

  const handlePageChange = (pageData) => {
    if (
      query.pageSize !== pageData.rows ||
      query.pageNo !== pageData.page + 1
    ) {
      setQuery({
        ...query,
        pageNo: pageData.page + 1,
        pageSize: pageData.rows,
      });
    }
  };

  const handleOnSortChange = (sortData) => {
    setQuery({
      ...query,
      pageNo: 1,
      sortColumn: sortData.sortField,
      sortBy: sortData.sortOrder === 1 ? "asc" : "desc",
    });
  };


//   const fetchLogs = useCallback(() => {
//   getNotificationLogs();
// }, [getNotificationLogs]);

// useEffect(() => {
//   fetchLogs();
// }, [fetchLogs]);

useEffect(() => {
  getNotificationLogs(query);
}, [query, getNotificationLogs]);

//  const exportUsers = (fileType) => {
//     notificationExportRequest({
//       fileType,
//       query: {
//         ...query,
//         sortColumn:
//           query.sortColumn === "name" ? "firstName" : query.sortColumn,
//       },
//       filters: filters
//         .filter((item) => item.values.length > 0)
//         .map((item) => ({
//           id: item.id,
//           values: item.values,
//           isDynamicField:
//             item.id !== "Designation" &&
//             item.id !== "Department" &&
//             item.id !== "ManagerId",
//         })),
//     });
//   };

 const exportNotifications = (fileType) => {

  notificationExportRequest({
    fileType,
    query: {
      ...query,
      sortColumn: query.sortColumn || "createdOn",
      sortBy: query.sortBy || "desc",
      pageNo: query.pageNo || 1,
      pageSize: query.pageSize || 50,
      namePattern: query.namePattern || "",
    },
    // filters: filters
    //   ?.filter((item) => item.values.length > 0)
    //   ?.map((item) => ({
    //     id: item.id,
    //     values: item.values,
    //     isDynamicField:
    //       item.id !== "Designation" &&
    //       item.id !== "Department" &&
    //       item.id !== "ManagerId",
    //   })),
  });
};

useEffect(() => {
  if (!query?.pageSize) {
    setQuery({
      pageNo: query?.pageNo || 1,
      pageSize: 50,
      sortBy: query?.sortBy || "desc",
      sortColumn: query?.sortColumn || "createdOn",
      namePattern: query?.namePattern || "",
    });
  }
}, []);

  return (
    <>
      <div>
        {(!isFromAssigment && (
          <CustomBreadCrumbs labels={labels} navigate={navigate} />
        )) ||
          null}
        <div
          className="edexlms-page-content"
          style={isFromAssigment ? { padding: 0 } : {}}
        >
          {(!isFromAssigment && (
            <div className="edexlms-page-header">
              <div className="edexlms-page-title">
                {intl.formatMessage({ id: "notification_audit" })}
              </div>
               <div className="edexlms-page-actions flex gap-2">

            <div className="block md:hidden">
              <Button
                icon="pi pi-ellipsis-v"
                style={{
                  color: "var(--edexlms-primary-color)",
                  padding: 0,
                  width: "100%",
                  height: "30px",
                  fontSize: "2rem",
                  backgroundColor: "ButtonFace",
                }}
                onClick={(event) => menuRef.current.toggle(event)}
              ></Button>
              <Menu
                ref={menuRef}
                model={[
                  {
                    label: "Export",
                    icon: "pi pi-fw pi-plus",
                    disabled: true,
                    template: () => {
                      return (
                        <div>
                          <div className="flex align-items-center px-2 py-2 gap-2">
                            <i
                              className="pi pi-download"
                              style={{ fontSize: "1rem", fontWeight: "bold" }}
                            ></i>
                            <span
                              style={{
                                fontSize: "1.1rem",
                                fontWeight: "bold",
                              }}
                            >
                              Export
                            </span>
                          </div>
                          <ul className=" export-menu-container">
                            <li onClick={() => exportNotifications("excel")}>
                              - EXCEL{" "}
                            </li>
                            <li onClick={() => exportNotifications("csv")}>- CSV </li>
                            <li onClick={() => exportNotifications("pdf")}>- PDF</li>
                          </ul>
                        </div>
                      );
                    },
                  },
                //   {
                //     label: "Show staticstics",
                //     icon: "pi pi-fw pi-plus",
                //     disabled: true,
                //     template: () => {
                //       return (
                //         <div
                //           className="flex align-items-center px-2 py-2 gap-2 cursor-pointer"
                //           style={{ fontWeight: "bold" }}
                //           onClick={() => setIsmobileViewSummaryShown(true)}
                //         >
                //           <i className="pi pi-chart-bar" />
                //           Show staticstics
                //         </div>
                //       );
                //     },
                //   },
                ]}
                popup
                id="popup_menu_right"
                popupAlignment="right"
              />
            </div>

            <div className="hidden md:block">
              <DropdownButton
                icon="pi pi-download"
                label={intl.formatMessage({ id: "export" })}
                items={[
                  {
                    label: intl.formatMessage({ id: "excel" }),
                    command: () => exportNotifications("excel"),
                  },
                  {
                    label: intl.formatMessage({ id: "csv" }),
                    command: () => exportNotifications("csv"),
                  },
                  {
                    label: intl.formatMessage({ id: "pdf" }),
                    command: () => exportNotifications("pdf"),
                  },
                ]}
              />
            </div>
          </div>
            </div>
          )) ||
            null}
          <div className="edexlms-page-body">
            <div className="edexlms-search-filter-bar">
              <TextInput
                // style={{ width: "800px" }}
                className="wide-input"
                iconPosition="left"
                icon="pi-search"
                placeholder={intl.formatMessage({
                  id: "search-audit",
                })}
                input={{
                  name: "search",
                  value: namePattern,
                  onChange: (e) => setNamePattern(e.target.value),
                //   style: { width: "600px" }, // ✅ move style here
                }}
              />
              {/* <TextInput
                iconPosition="left"
                icon="pi-search"
                placeholder={intl.formatMessage({
                  id: "search_created_by",
                })}
                input={{
                  name: "search",
                  value: createdByNamePattern,
                  onChange: (e) => setCreatedByNamePattern(e.target.value),
                }}
              /> */}
            </div>
            <List
              pageQuery={query}
              handlePageChange={handlePageChange}
              handleOnSortChange={handleOnSortChange}
              loading={action === "list" && requesting}
              data={notificationLogs || []}
              totalRecords={totalCount}
              // handleRowClick={(data) => {
              //   if (!isFromAssigment) {
              //     navigate(
              //       `${RouteConstants.APP_ROUTE_ADMINISTRATION_AUDIENCES_EDIT.replace(
              //         ":id",
              //         data?.data?.id
              //       )}`
              //     );
              //   } else {
              //     navigate(
              //       `${RouteConstants.APP_ROUTE_ASSIGNMENTS_AUDIENCE.replace(
              //         ":id",
              //         data?.data?.id
              //       )}`
              //     );
              //   }
              // }}
              selectionMode=""
              columns={[
               
                {
                  field: "notificationName",
                  header: "Notification Name",
                   sortable: true,
                },
                 {
                  field: "name",
                  header: "User Name",
                   sortable: true,
                },
                 {
                                 field: "isSent",
                                 header: "status",
                                  sortable: true,
                                 body: ListCellRenders.SentStatus,
                               },
                 {
                  field: "triggeredOn",
                  header: "Executed-On",
                   sortable: true,
                   body: ListCellRenders.DateTime("triggeredOn"),
                },
                 {
                  field: "createdOn",
                  header: "Created-On",
                   sortable: true,
                  body: ListCellRenders.DateTime("createdOn"),
                },
                {
                  field: "createdByName",
                  header: "Created-by",
                   sortable: true,
                //   body: ListCellRenders.CreatedBy,
                },
                {
                  field: "updatedOn",
                  header: "Updated-On",
                   sortable: true,
                //   body: ListCellRenders.DateTime("createdAt"),
                body: ListCellRenders.DateTime("updatedOn"),
                },
                {
                  field: "updatedByName",
                  header: "Updated-By",
                   sortable: true,
                //   body: ListCellRenders.DateTime("updatedAt"),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state?.self?.user,
  action: state?.notifications?.action,
  requesting: state?.notifications?.requesting,
  error: state?.notifications?.error,
  query: state?.notifications?.query,
  totalCount: state?.notifications?.data?.totalCount,
  notificationLogs: state?.notifications?.data?.list || [],
  filters: state?.users?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  listRequest: (query) => dispatch(listRequest(query)),
  setQuery: (query) => dispatch(setQuery(query)),
//   getNotificationLogs: () => dispatch({ type: "notifications/GetNotificationLogs" }),
  getNotificationLogs: (query) =>
    dispatch({ type: "notifications/GetNotificationLogs", payload: query }),
//   userExportRequest: (data) => dispatch(userExportRequest(data)),
  notificationExportRequest: (data) => dispatch(notificationExportRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationLogList);
